import { Routes, Route, Navigate } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import { SplashScreen } from './components/splash-screen'
import { useSplash } from './hooks/use-splash'
import { usePlatform } from './hooks/use-platform'
import { CookieBanner } from './components'
import { LandingPage } from './pages/landing/landing-page'
import {
    LegalLayout,
    PrivacyPolicyPage,
    TermsOfUsePage,
    LgpdPage,
    CookiePolicyPage,
    BusinessTermsPage,
    DataRightsPage,
    CommunityGuidelinesPage
} from './pages/legal'

function App() {
    const showSplash = useSplash()
    const { platform } = usePlatform()
    const isNative = platform === 'ios' || platform === 'android'

    return (
        <>
            <AnimatePresence>
                {showSplash && <SplashScreen key="splash" />}
            </AnimatePresence>

            {!showSplash && (
                <>
                    <CookieBanner />
                    <Routes>
                        <Route
                            path="/"
                            element={isNative ? <Navigate to="/login" replace /> : <LandingPage />}
                        />

                        {/* Placeholder Routes for Auth (Task 1.5) */}
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPage />} />

                        {/* Legal Routes */}
                        <Route path="/legal" element={<LegalLayout />}>
                            <Route path="privacy" element={<PrivacyPolicyPage />} />
                            <Route path="terms" element={<TermsOfUsePage />} />
                            <Route path="lgpd" element={<LgpdPage />} />
                            <Route path="cookies" element={<CookiePolicyPage />} />
                            <Route path="business-terms" element={<BusinessTermsPage />} />
                            <Route path="data-rights" element={<DataRightsPage />} />
                            <Route path="community" element={<CommunityGuidelinesPage />} />
                        </Route>

                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </>
            )}
        </>
    )
}

function LoginPage() {
    return (
        <main className="min-h-screen flex items-center justify-center bg-background">
            <div className="text-center">
                <h1 className="text-2xl font-bold mb-4">Login (Native/App)</h1>
                <p className="text-muted-foreground">Flow de autenticação será implementado na Tarefa 1.5</p>
            </div>
        </main>
    )
}

function RegisterPage() {
    return (
        <main className="min-h-screen flex items-center justify-center bg-background">
            <div className="text-center">
                <h1 className="text-2xl font-bold mb-4">Cadastro</h1>
                <p className="text-muted-foreground">Flow de cadastro será implementado na Tarefa 1.5</p>
            </div>
        </main>
    )
}

function NotFoundPage() {
    return (
        <main className="min-h-screen bg-background text-foreground flex items-center justify-center">
            <div className="text-center space-y-4">
                <h1 className="font-display text-6xl font-bold text-primary">404</h1>
                <p className="font-sans text-lg text-muted-foreground">
                    Página não encontrada
                </p>
            </div>
        </main>
    )
}

export default App
